export default "__VITE_ASSET__DjUkSNtt__"